export default {
  SET_ONE_OBJECT(state, data) {
    state.single_attachment = data
  },
}
